import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import Typography from '@/common/components/base/typography/Typography';
import { Flex } from 'styled-system/jsx';
import TickIcon from '../../assets/icons/walletTick.svg?react';

export default function SettlementYearModal({
  closeModal,
  open,
  years,
  activeYear,
  onSelect,
}: MainModalProps & {
  years: number[];
  activeYear: number;
  onSelect: (year: number) => void;
}) {
  return (
    <MainModal
      title="دوره تسویه"
      titleLineColor="purple-primary"
      closeModal={closeModal}
      open={open}
    >
      <Flex flexDirection={'column'} gap={8} mt={-16} pb={8}>
        {[...years]
          .sort((a, b) => b - a)
          .map((year) => (
            <Flex
              key={year}
              alignItems={'center'}
              justifyContent={'space-between'}
              bgColor={'white'}
              borderRadius={8}
              px={12}
              py={4}
              cursor={'pointer'}
              filter={'drop-shadow(0px 4px 4px rgba(191,191,191,0.1))'}
              onClick={() => {
                onSelect(year);
                closeModal();
              }}
            >
              <Typography color={'black'}>{year}</Typography>
              {year === activeYear && <TickIcon />}
            </Flex>
          ))}
      </Flex>
    </MainModal>
  );
}
